import { type IconName } from "components/Icon";
import { Toggle } from "components/Toggle";
import { EnergyAnalysisSettingsGroup } from "features/energy-analysis-dashboard/components/EnergyAnalysisSettingsGroup";
import { useTranslation } from "react-i18next";

import type { CrremPathwayScale } from "../model/types";

import { CRREM_PATHWAY_SCALE } from "../model/constants";

const SCALE_OPTIONS: {
  iconName: IconName;
  key: CrremPathwayScale;
  labelKey: "grossArea" | "netLettableArea" | "scaleNone";
}[] = [
  { iconName: "Ban", key: CRREM_PATHWAY_SCALE.none, labelKey: "scaleNone" },
  { iconName: "Maximize2", key: CRREM_PATHWAY_SCALE.grossArea, labelKey: "grossArea" },
  { iconName: "Crop", key: CRREM_PATHWAY_SCALE.netLettableArea, labelKey: "netLettableArea" },
];

type CrremPathwayScaleControlProps = {
  onChange: (value: CrremPathwayScale) => void;
  value: CrremPathwayScale;
};

export const CrremPathwayScaleControl = ({ onChange, value }: CrremPathwayScaleControlProps) => {
  const { t } = useTranslation();
  return (
    <EnergyAnalysisSettingsGroup iconName="BuildingIcon" label={t("BuildingProfile.energyAnalysis.settings.scale")}>
      <Toggle
        onChange={onChange}
        options={SCALE_OPTIONS.map((option) => ({
          iconName: option.iconName,
          label: t(`BuildingProfile.energyAnalysis.settings.${option.labelKey}`),
          value: option.key,
        }))}
        value={value}
      />
    </EnergyAnalysisSettingsGroup>
  );
};
